export default __webpack_public_path__ + "static/media/PAGOSYFACTURACION.993d5979.gif";